import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { constants } from 'src/app/config/constants';
import { PageRes } from 'src/app/models/datatable/page-res';
import { ValueAccessorBase } from 'src/app/shared/inputs/value-accessor-base';

@Component({
  selector: 'app-datatable-footer',
  templateUrl: 'datatable-footer.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatatableFooterComponent),
      multi: true
    }
  ]
})
export class DatatableFooterComponent extends ValueAccessorBase<any> {
  @Input() isHasData: boolean;
  @Input() totalPages: number;
  @Input() totalElement: number;
  @Input() size: number;
  @Input() searchResult: Boolean;
  maxPageSize: number = constants.maxPageSize;
}
